import React from 'react';
import PropTypes from 'prop-types';
import IconHeader from '../../../../../../../shared/components/IconHeader/IconHeader';

const Section = (props) => {
  const percentages = () => {
    const metadata = props.metadata;
    const items = metadata.items.map((item, index) => {
      const key = `${item.title}${index}`;

      return (
        <div className='col-xs-12 col-sm-4' key={key}>
          <div className='highlights'>
            <div className='innerHighlights'>
              <h4 className='title'>{item.title}</h4>
              <h5 className='percentage'>{!item.percentage ? '0%' : `${item.percentage}%`}</h5>
            </div>
          </div>
          <p className='definition'>{item.definition}</p>
        </div>
      );
    });

    if (items && items.length < 3) {
      for (let index = items.length; index < 3; index++) {
        items.push(<div className='hidden-xs col-sm-4 highlights' key={index} />);
      }
    }

    return items;
  };

  return (
    <div className={`section${props.isOverview ? ' overview' : ''}`}>
      <div className=''>
        <IconHeader title={props.title} icon={props.icon} />
      </div>
      <p className='subtitle'>{props.metadata.sectionSubtitle}</p>
      <div className='row equal'>
        {percentages()}
      </div>
    </div>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  isOverview: PropTypes.bool,
  metadata: PropTypes.object,
};

export default Section;



// WEBPACK FOOTER //
// ./modules/DataExports/components/shared/MetadataChart/children/Section/Section.js